import styled from 'styled-components/macro';
import { FlexJustifyCenter, FlexAlignCenter } from '../../../../../shared-styles/flex';

export const NavButton = styled.button`
  ${FlexJustifyCenter}
  ${FlexAlignCenter}
  height: 50px;
  width: 50px;
  color: ${({ theme }) => theme.palette.white};
  background-color: ${({ isActive, theme }) => (isActive ? theme.palette.custom.navButtonActive : theme.palette.darkBlue[100])};
  border: none;
  transition: 0.3s;
  cursor: pointer;

  &:focus {
    outline: none;
  }
  
  &:hover {
    background-color: ${({ theme }) => theme.palette.custom.navButtonActive};
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: 50px;
  right: 0px;
  z-index: 10;
  width: 240px;
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: 0px 3px 6px #00000029;

  *:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.lightGray[100]};
  }
`;

export const DropdownRow = styled.div`
  ${FlexAlignCenter}
  padding: ${({ theme }) => theme.spacing(8)} ${({ theme }) => theme.spacing(15)};
  color: ${({ theme }) => theme.palette.darkGray[100]};
  font-size: ${({ theme }) => theme.typography.sizes.small};
  user-select: none;
  cursor: pointer;
  transition: background-color 0.3s;

  svg {
    margin-right: ${({ theme }) => theme.spacing(10)};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.lightBlue[50]};
  }
`;
